import styles from "./acardeon.module.css";
import { useMeals, useMealsAction } from "../../../../Context/MealsProvider";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";

import { AiOutlinePlus } from "react-icons/ai";
const Acardeon = ({ index, dayIndex }) => {
  const meals = useMeals();
  const dispatch = useMealsAction();
  const toggleAccordion = () => {
    const el = document.querySelector(`#accordion-${index}-${dayIndex}`);
    if (el.classList.contains("show")) {
      el.classList.replace("show", "collapsed");
    } else {
      el.classList.add("show");
    }
  };
  return (
    <div>
      <p>
        <button
          className={`btn ${styles.btnacardeon}`}
          type="button"
          onClick={toggleAccordion}
        >
          <AiOutlinePlus />
        </button>
      </p>
      <div className="collapse" id={`accordion-${index}-${dayIndex}`}>
        <div style={{ marginTop: "22px" }}>
          <div className={styles.containerAcardeon}>
            <div className={styles.containerMain}>
              <div className={styles.formInput}>
                <p className={styles.text}>نام</p>
                <input
                  type="text"
                  className={styles.inputBox}
                  value={meals[dayIndex][index].onvan}
                  onChange={(e) =>
                    dispatch({
                      type: "changeHandlerOnvan",
                      day: dayIndex,
                      id: index,
                      event: e,
                    })
                  }
                />
              </div>
              <div className={styles.formInput}>
                <p className={styles.text}>شماره</p>
                <input
                  type="text"
                  className={styles.inputBox}
                  value={meals[dayIndex][index].tel}
                  onChange={(e) =>
                    dispatch({
                      type: "changeHandlerTel",
                      day: dayIndex,
                      id: index,
                      event: e,
                    })
                  }
                />
              </div>
              <div className={styles.formInput}>
                <p className={styles.text}>آدرس</p>
                <textarea
                  type="text"
                  className={styles.inputBoxbig}
                  value={meals[dayIndex][index].address}
                  onChange={(e) =>
                    dispatch({
                      type: "changeHandlerAddress",
                      day: dayIndex,
                      id: index,
                      event: e,
                    })
                  }
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Acardeon;
